module.exports = __webpack_public_path__ + "assets/img/m-list-logo-zh.f926371c.png";